// 运行时配置加载器
// 配置文件位于 public/config.json，打包后可在线上直接修改

let config = null
let configPromise = null

// 默认配置（加载失败时使用）
const defaultConfig = {
  api: {
    baseUrl: 'http://localhost:8060',
    sseChat: '/api/deepseek/chat'
  }
}

/**
 * 加载配置文件
 * @returns {Promise<Object>} 配置对象
 */
export async function loadConfig () {
  if (config) {
    return config
  }

  if (configPromise) {
    return configPromise
  }

  configPromise = fetch('/config.json?t=' + Date.now())
    .then(res => {
      if (!res.ok) {
        throw new Error('配置文件加载失败')
      }
      return res.json()
    })
    .then(data => {
      config = data
      return config
    })
    .catch(err => {
      console.warn('[Config] 加载配置失败，使用默认配置:', err.message)
      config = defaultConfig
      return config
    })

  return configPromise
}

/**
 * 获取配置（同步，需先调用 loadConfig）
 * @param {string} key 配置键，支持点分隔，如 'api.baseUrl'
 * @param {*} defaultValue 默认值
 * @returns {*} 配置值
 */
export function getConfig (key, defaultValue = undefined) {
  const source = config || defaultConfig
  if (!key) {
    return source
  }

  const keys = key.split('.')
  let value = source
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k]
    } else {
      return defaultValue
    }
  }
  return value
}

/**
 * 获取 API 基础地址
 */
export function getApiBaseUrl () {
  return getConfig('api.baseUrl', defaultConfig.api.baseUrl)
}

/**
 * 获取 SSE 聊天完整地址
 */
export function getSseChatUrl () {
  return getApiBaseUrl() + getConfig('api.sseChat', defaultConfig.api.sseChat)
}

export default {
  loadConfig,
  getConfig,
  getApiBaseUrl,
  getSseChatUrl
}
